/**
 * Access window.localStorage without throwing when storage is unavailable
 * (private mode, quota, sandboxed iframe SecurityError, enterprise policy, etc.).
 */
export function safeLocalStorageGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeLocalStorageSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}
